{
  "moreNews": "Más noticias"
}
